import { useModuleBEM } from "@b2bportal/core-themes";
import type { HotelItinerarySummary } from "@b2bportal/lodging-api";
import type { Product } from "@b2bportal/purchase-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import { ActionButton, Card } from "../../../../../components";
import styles from "./UpcomingTripCard.module.scss";
import { useTripCard } from "./useTripCard";
import { Typography } from "@/components";
import type { GroundBookingContext } from "@/utils/commerce/types";

export const UpcomingTripCard = ({
  reservationId,
  reservation,
  productType,
  onSelectTrip,
}: {
  reservationId: string;
  reservation: HotelItinerarySummary | GroundBookingContext;
  productType?: Product;
  onSelectTrip: (reservationId: string) => void;
}) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "UpcomingTripCard");
  const { handlers, text, icon } = useTripCard({
    reservation,
    productType,
    selectItinerary: () => onSelectTrip(reservationId),
  });

  return (
    <Card>
      <div className={cn("header")}>
        <Icon iconName={icon} useCurrentColor={false} className={cn("icon")} />
        <div className={cn("header-text")}>
          <Typography weight="bold" size="md">
            {text.title}
          </Typography>
          <Typography size="sm" color="var(--text-subdued)">
            {text.product}
          </Typography>
        </div>
      </div>
      <div className={cn("info")}>
        <div className={cn("info-dates")}>
          <Typography size="sm">{text.dates}</Typography>
          <Typography size="sm" weight="bold">
            {text.location}
          </Typography>
        </div>
        <ActionButton
          onClick={handlers.selectItinerary}
          defaultStyle="outlined"
          message={t("home.upcomingTrips.cta")}
        />
      </div>
    </Card>
  );
};
